import { TABLA_PEDIDO_CAMIONES_EN_PLAYA } from '../../../../../../config/tables'
import { COLUMNS_PEDIDO_CAMIONES_EN_PLAYA, COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_TO_PRINT } from './constantesPedidoCamionesEnPlaya'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import PedidoEgreso from '../../../../../../models/camiones/pedido_egreso'
import { toast } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../../config/settings'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_PEDIDO_CAMIONES_EN_PLAYA
    })
    PedidoEgreso.getDataPedidosCamionesEnPlaya().then(callback)
    function callback (data) {
      const customToolbar = pdfCustomToolbarGenerator(
        'Listado de Pedidos',
        data,
        COLUMNS_PEDIDO_CAMIONES_EN_PLAYA_TO_PRINT,
        'landscape')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_PEDIDO_CAMIONES_EN_PLAYA,
          data: data,
          title: `Listado de Pedidos`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: true, rowsPerPage: 50, rowsPerPageOptions: [50, 100] }
        },
        id: TABLA_PEDIDO_CAMIONES_EN_PLAYA
      })
    }
  }
}

export function eliminarPedidoCamiones (fecha) {
  return dispatch => {
    PedidoEgreso.eliminarPedido(fecha)
      .then(data => {
        dispatch({ type: 'ELIMINAR_PEDIDO' })
        if (!data.error) {
          dispatch(actualizarDatosParaMuiTable())
          toast.success('Pedido eliminado exitosamente.', { autoClose: INTERVALO_CORTO })
        }
      })
  }
}
